define.alias("checkout/components/payment/coupon", "calendar/components/payment/coupon");